import { Extensions, type Block } from 'blockly/core';

export const BEGINNER_PIXEL_CUSTOM_COLOUR_EXTENSION = 'beginner_pixel_custom_colour_fields';
export const BEGINNER_PIXEL_CUSTOM_COLOUR_FIELD = 'CUSTOM_COLOUR';

function updatePixelCustomColourField(block: Block, colorValue?: string): void {
  const preset = colorValue ?? String(block.getFieldValue('COLOR') ?? '');
  const showCustom = preset === 'CUSTOM';
  block.getField(BEGINNER_PIXEL_CUSTOM_COLOUR_FIELD)?.setVisible(showCustom);
  // Force a re-render so the colour swatch appears/disappears cleanly.
  const maybeSvg = block as unknown as { render?: () => void };
  maybeSvg.render?.();
}

let registered = false;

export function registerBeginnerPixelCustomColourExtension(): void {
  if (registered || Extensions.isRegistered(BEGINNER_PIXEL_CUSTOM_COLOUR_EXTENSION)) {
    registered = true;
    return;
  }

  Extensions.register(BEGINNER_PIXEL_CUSTOM_COLOUR_EXTENSION, function (this: Block) {
    this.getField('COLOR')?.setValidator((value) => {
      updatePixelCustomColourField(this, String(value ?? ''));
      return value;
    });
    updatePixelCustomColourField(this);
  });

  registered = true;
}
